import { createReducer, on } from "@ngrx/store";
import { iEntrada, mEntrada } from "../../entrada/entrada.interface";
import { cargarEntradas, cargarEntradasSuccess } from "./actions";
import { IEntradas, IEntradasInitState } from "../../interfaces/entradas";

export const initialState: IEntradas = IEntradasInitState;

export const entradasReducer = createReducer(
  initialState,
  on(cargarEntradasSuccess, (state, { entradas }) => {
    return { ...state, entradas };
  })
);
